<div mat-dialog-title>

  @if (step == 1 || step == 2) {
    <h1 class="titulo-simpli">Carga tu nómina de facturas</h1>
  }

  @if (step == 3) {
    <h1 class="titulo-simpli">Resumen de las facturas agregadas </h1>
  }
  @if (step == 3 && empty_facturas == false) {
    <small class="subtitulo-simpli">Selecciónalas para ver toda la
    información.</small>
  }


</div>

<div mat-dialog-content [ngStyle]="is_responsive ? {'min-height': '85vh'} : {}">

  <!--STEPPER CONTROL-->
  @if (step == 1 || step == 2) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn"
      style="margin-top: 40px;">
      <div class="container-stepper-simpli">
        <div id="step-simpli1" class="stepper-simpli stepper-simpli-active" (click)="change_step('step-simpli1')">
          <span class="material-symbols-outlined">download</span>
          <div class="step-text">Descargar plantilla</div>
          <div class="line-step-simpli"></div>
        </div>
        <div id="step-simpli2" class="stepper-simpli" (click)="change_step('step-simpli2')">
          <span class="material-symbols-outlined">upload</span>
          <div class="step-text">Subir nómina</div>
        </div>
      </div>
    </div>
  }


  @if (step == 1) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn">
      <div class="l-simpli">Descarga la plantilla excel, ingresa la nómina</div>
      <div class="l-simpli">en ella y evita errores en el proceso.</div>
      <div class="l-simpli link-label" (click)="download_nomina()">Descarga la plantilla aquí</div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
          <div [ngClass]="{'btn-simpli-container':true}">
            <button class="secondary-button" mat-dialog-close mat-flat-button>
              Cerrar
            </button>
            <button mat-flat-button [ngClass]="{'primary-button':true}" (click)="change_step('step-simpli2')">
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (step == 2) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn">
      @if (file_name == '') {
        <div class="l-simpli" style="margin-top: 20px;">Sube la plantilla (formato .XLSX),</div>
      }
      @if (file_name == '') {
        <div class="l-simpli"> con tu nómina ya ingresada</div>
      }
      @if (file_name != '') {
        <div class="l-simpli estilo-especial" style="margin-top: 20px;">¡Datos cargados! Si
        necesitas reemplazar el archivo, elimínalo y sube uno nuevo. </div>
      }
      <div class="l-simpli link-label2">{{file_name}} @if (file_name != '') {
        <span (click)="delete_nomina()" matTooltip="Eliminar"
          style="margin-left: 10px;cursor: pointer;"><span class="material-symbols-outlined">close</span></span>
        }
      </div>
      <input id="upload_files" type="file" (change)="upload_file($event)" style="display: none;"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
          @if (file_name == '') {
            <div [ngClass]="{'btn-simpli-container':true}">
              <button class="secondary-button" mat-dialog-close mat-flat-button>
                Cerrar
              </button>
              <button mat-flat-button [ngClass]="{'primary-button':true}" (click)="subir_momina()">
                Subir nómina
              </button>
            </div>
          }
          @if (file_name != '') {
            <div [ngClass]="{'btn-simpli-container':true}">
              <button [disabled]="loading" mat-flat-button [ngClass]="{'primary-button':true}" (click)="pasar_a_revision()">
                @if (!loading) {
                  <mat-label>Continuar</mat-label>
                }
                @if (loading) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:white;">progress_activity</span></span>
                }
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!--RESUMEN DE LAS FACTURAS AGREGADAS-->
  @if (step == 3) {
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn">
      @if (has_error == true) {
        <div class="box-error">
          <div class="row">
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-2">
              <div style="margin-top:8px;">
                <span class="material-symbols-outlined" style="font-size: 25px;">info</span>
              </div>
            </div>
            <div class="col-lg-11 col-md-11 col-sm-11 col-xs-10">
              Algunas facturas presentan errores de formato. Corrige los datos dentro de los campos editables y selecciona
              “Guardar cambios” para continuar.
            </div>
          </div>
        </div>
      }
      @if (empty_facturas == false) {
        <div id="container-facturas" class="container-exp add_factoring">
          <mat-accordion multi="true">
            @for (i of obs | async; track i; let index = $index) {
              <mat-expansion-panel
                [expanded]="(i.errorReemitida != null || i.errorFechaEmision != null || i.errorFolio != null || i.errorMonto != null || i.errorRut != null)"
                [ngClass]="{'error-facturas': i.errorFechaEmision != null || i.errorReemitida != null || i.errorFolio != null || i.errorMonto != null || i.errorRut != null, 'mas_alto':i.errorFolio != null && i.errorMonto != null}"
                style="margin-bottom: 15px;">
                <mat-expansion-panel-header style="position: relative;">
                  <mat-panel-title>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="c-exp">
                          <div class="l-exp-i"><input class="no-input l-exp-i error-label-noeditable" readonly
                          value="N° Factura:"></div>
                          <div class="l-exp-d">
                            @if (i.errorFolio == null) {
                              <input class="no-input l-exp-d error-label-noeditable" readonly
                                value="{{i.folio}}">
                            }
                            @if (i.errorFolio != null) {
                              <input (click)="$event.stopPropagation();" id="folio_{{index}}"
                                (change)="change_folio($event, index)" type="number"
                                class="l-exp-d error-label" placeholder="{{i.folio}}">
                            }
                            @if (i.errorFolio != null) {
                              <span matTooltip="{{i.errorFolio}}"
                                class="material-icons-outlined floaticon">
                                info
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="c-exp">
                          <div class="l-exp-i"><input class="no-input l-exp-i error-label-noeditable" readonly value="Monto:">
                          </div>
                          <div class="l-exp-d">
                            @if (i.errorMonto == null) {
                              <input class="no-input l-exp-d" readonly
                                value="${{formatMoney(i.monto)}}">
                            }
                            @if (i.errorMonto != null) {
                              <input (click)="$event.stopPropagation();" id="monto_{{index}}"
                                (keyup)="format_monto($event, index)" (change)="change_monto($event, index)" type="text"
                                class="l-exp-d error-label" placeholder="{{i.monto}}">
                            }
                            @if (i.errorMonto != null) {
                              <span matTooltip="{{i.errorMonto}}"
                                class="material-icons-outlined floaticon">
                                info
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="c-exp">
                          <div class="l-exp-i"><input class="no-input l-exp-i error-label-noeditable" readonly
                          value="Deudor:"></div>
                          <div class="l-exp-d"><input class="no-input l-exp-d error-label-noeditable" readonly
                          value="{{i.deudor}}"></div>
                        </div>
                      </div>
                    </div>
                  </mat-panel-title>
                  <mat-panel-description class="exp-desc">
                    <div class="icon-mas-alto" style="margin-top: 20px;margin-right: 10px;z-index: 999999999;"
                      matTooltip="Eliminar factura" (click)="delete_factura(i.folio);$event.preventDefault();"><span class="material-symbols-outlined exp-delete">delete</span></div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="row" style="margin-top: 20px;">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="c-exp">
                      <div class="l-exp-i"><input class="no-input l-exp-i" readonly value="RUT:"></div>
                      <div class="l-exp-d">
                        @if (i.errorRut == null) {
                          <input class="no-input l-exp-d" readonly value="{{i.rut}}">
                        }
                        @if (i.errorRut != null) {
                          <input (click)="$event.stopPropagation();" id="rut_{{index}}" (keyup)="rut_key($event, index)"
                            class="l-exp-d error-label-rut" placeholder="{{i.rut}}">
                        }
                        @if (i.errorRut != null) {
                          <span matTooltip="{{i.errorRut}}"
                            class="material-icons-outlined floaticonrut">
                            info
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="c-exp">
                      <div class="l-exp-i"><input class="no-input l-exp-i" readonly value="Fecha emisión:"></div>
                      <div class="l-exp-d">
                        @if (i.errorFechaEmision == null) {
                          <input class="no-input l-exp-d" readonly
                            value="{{i.fecha_emision}}">
                        }
                        @if (i.errorFechaEmision != null) {
                          <input (click)="picker2.open();$event.stopPropagation();" id="fecha_{{index}}"
                            class="l-exp-d error-label-rut"
                            placeholder="{{i.errorFechaEmision}}">
                        }
                        @if (i.errorFechaEmision != null) {
                          <span matTooltip="{{i.errorFechaEmision}}"
                            class="material-icons-outlined floaticonrut">
                            info
                          </span>
                        }
                        <mat-form-field style="visibility: hidden;width: 1px;height: 1px;position: absolute;">
                          <input matInput readonly [matDatepicker]="picker2"
                            (dateChange)="fecha_individual_emision($event, index)">
                          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                          <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                      </div>
                    </div>
                    @if (error_reemitida == true) {
                      <div class="c-exp">
                        <div class="l-exp-i"><input class="no-input l-exp-i" readonly value="Error:"></div>
                        <div class="l-exp-d"><input class="no-input l-exp-d" readonly value="Esta factura no es de reemplazo.">
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      }
      <div class="row">
        @if (facturas.length > 0) {
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top" style="text-align: center;"
            >
            <mat-paginator [pageSizeOptions]="[6, 12, 24]"></mat-paginator>
          </div>
        }
      </div>
      @if (empty_facturas == false) {
        <div class="sep">
          <mat-label class="label-i">Monto total</mat-label>
          <mat-label class="label-d">${{formatMoney(monto_total)}}</mat-label>
        </div>
      }
      @if (empty_facturas == true) {
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
            <div class="c-simpli">
              <div style="text-align: center;margin-bottom: 30px;">
                <span class="material-symbols-outlined i-simpli">warning</span>
              </div>
              <div class="l-simpli">
                Debes agregar por lo menos 1 factura
              </div>
              <div class="l-simpli">
                para realizar la simulación
              </div>
            </div>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
          <div [ngClass]="{'btn-simpli-container':true}">
            @if (has_error == false && reemitida_mode == false) {
              <button mat-flat-button
                [ngClass]="{'primary-button':true}" (click)="go_to_simular()">
                @if (open_as_dialog == false) {
                  <mat-label>Iniciar simulación</mat-label>
                }
                @if (open_as_dialog == true) {
                  <mat-label>Continuar</mat-label>
                }
              </button>
            }
            @if (has_error == false && reemitida_mode == false) {
              <button mat-flat-button (click)="add_mas_facturas()"
                [ngClass]="{'secondary-button':true}">
                Agregar más facturas
              </button>
            }
            @if (reemitida_mode == true) {
              <button [disabled]="error_reemitida" mat-flat-button
                [ngClass]="{'primary-button':true, 'disabled_btn':error_reemitida == true}" (click)="go_to_simular()">
                Continuar
              </button>
            }
            @if (has_error == true && reemitida_mode == false) {

              <button mat-flat-button class="secondary-button" mat-dialog-close>
                  <span>Cerrar</span>
              </button>

              <button [disabled]="disabled || loading" mat-flat-button
                (click)="validate_facturas()" [ngClass]="{'primary-button':true, 'disable-btn':empty_facturas == true}">
                @if (loading) {
                  <span>
                    <span class="material-symbols-outlined mat-spin" style="color: var(--simpli-secondary);">progress_activity</span>
                  </span>
                }
                @if (!loading) {
                  <span>Guardar cambios</span>
                }
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }


</div>